import noReferrer from './furillo/no-referrer.js';
import ajaxPartials from './furillo/ajax-partials.js';
import cookieHelper from './furillo/cookie-helper.js';
import TagFilter from './furillo/tag-filter.js';
import { navbarDropdownOverrides } from './furillo/navigation.js';
import { offcanvasOverrides } from './furillo/offcanvas.js';
import imageGallery from './furillo/image-gallery.js';
import aos from '../../vendor/aos/dist/aos.js';
import lazyframe from '../../vendor/lazyframe/dist/lazyframe.min.js';
import Collapse from '../../vendor/bootstrap/js/dist/collapse.js';
import Offcanvas from '../../vendor/bootstrap/js/dist/offcanvas.js';
import Alert from '../../vendor/bootstrap/js/dist/alert.js';
//import FurilloOpenLayersMap from './furillo/openlayers-map.js';
import FurilloGoogleMaps from './furillo/google-maps.js';
import FurilloCompanyList from './furillo/company-list.js';

export default document.addEventListener('DOMContentLoaded', function () {

    // Add noreferrer to links
    noReferrer(document.querySelector('body'));

    // Modify default behaviour of navbar
    navbarDropdownOverrides(document.querySelector('#site > header nav.navbar'));

    // TODO: Check if we need to do anything at all with this?
    //offcanvasOverrides(document.querySelector('#site > header nav.navbar'));

    // Init ajax partials
    ajaxPartials.init(document.querySelector('body'));

    // Init animations
    aos.init({
        offset: 0,
        duration: 600,
        easing: 'ease-in-out',
        delay: 100,
        once: true
    });

    // Check for iframes and load them with lazy frame
    const frames = document.querySelectorAll('.lazyframe');
    if (frames && frames.length > 0) {
        lazyframe(frames);
    }

    // Check for image blocks and add possibility to open as modal
    const images = document.querySelectorAll('.block-image a.open-image-modal');
    if (images && images.length > 0) {
        images.forEach(image => {
            image.setAttribute('data-bs-toggle', 'modal');
            image.setAttribute('data-bs-target', '#image-gallery-modal');
        });
    }
    imageGallery(document.querySelector('#image-gallery-modal'));

    // Check for lists with tag filters and add filtering
    const filteredLists = document.querySelectorAll('.published-content-list .tag-filters');
    if (filteredLists && filteredLists.length > 0) {
        filteredLists.forEach(list => {
            const filter = new TagFilter(list);
        });
    }

    // Workaround, in Bootstrap v5.1.3 one could have "visibility: hidden" on the
    // offcanvas in order to hide it at load (no flicker). This no longer works so
    // lets remove them here once DOM is loaded.
    document.querySelectorAll('.offcanvas').forEach(element => {
        element.removeAttribute('style');
    });

    // Contact Cards
    const mapBlock = document.querySelector('.block-contactcardsmap');
    if (mapBlock) {
        // Get html and init google maps
        ajaxPartials.makeRequest(mapBlock.querySelector('div[data-ajax-url]'),
            function () {
                window.furillomaps = new FurilloGoogleMaps(mapBlock.querySelector('.google-maps-placeholder'),
                    {
                        apiKey: 'AIzaSyA2HUGzJeh_umktNKivtR2oA54zhDsDw9U',
                        mapId: 'a6bd6929e1e18795',
                        onMapLoaded: function (instance) {
                            var list = new FurilloCompanyList(mapBlock);
                        }
                    });
            });
    } else {
        const container = document.querySelector('.google-maps-placeholder');
        if (container) {
            window.furillomaps = new FurilloGoogleMaps(container, { apiKey: 'AIzaSyA2HUGzJeh_umktNKivtR2oA54zhDsDw9U', mapId: 'a6bd6929e1e18795' });
        }
    }

    // Set focus on search
    //shown.bs.collapse
    document.querySelector('#header-search').addEventListener('shown.bs.collapse', event => {
        event.target.querySelector('input[type="text"]').focus();
    });

    
    const forms = document.querySelectorAll('div.umbraco-forms-form > form');
    if (forms && forms.length > 0) {
        forms.forEach(form => {

            //// When SEO Checker messes with redirects
            //let action = form.getAttribute('action');
            //if (!action.endsWith('/')) {
            //    form.setAttribute('action', action + '/');
            //}

            // TODO: Check if has class to only move for that theme

            // Since Bootstrap 5 Theme needs other markup we need to handle displaying
            // the validation messages manually for RadioButtonList and CheckBoxList
            form.addEventListener('validation', function (e) {

                if (e.detail.valid)
                    return;
                    
                const displayListValidationMessages = function (selector) {
                    e.target.querySelectorAll(selector).forEach(list => {

                        let check = list.querySelector('input.input-validation-error');
                        if (!check)
                            return;

                        let id = check.getAttribute('name');
                        list.parentNode.querySelector('span[data-valmsg-for="' + id + '"]').style.display = 'inline-block';
                    });
                };

                displayListValidationMessages('.radiobuttonlist');
                displayListValidationMessages('.checkboxlist');                
            });
        });
    }
});

